import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import { get } from 'lodash';

export const RichTextField = ({ content, record, source }) => {
  const contentString = content || get(record, source);

  if (!contentString) return null;

  return (
    <div dangerouslySetInnerHTML={{ __html: contentString }} />
  );
};

const selector = getFormValues('record-form');

export default connect(
  (state) => ({ record: selector(state) }),
)(RichTextField);
